import React from 'react';
import styled from 'styled-components';
import { spacing } from '../../style/theme';
var PaddedCenteredWrapper = styled.div.withConfig({
  displayName: "ProductsImporting__PaddedCenteredWrapper",
  componentId: "gq2o5a-0"
})(["padding:", "px;text-align:center;"], spacing.base);

var ProductsImporting = function ProductsImporting() {
  return React.createElement(PaddedCenteredWrapper, null, React.createElement("span", null, "Importing. Please wait."));
};

export default ProductsImporting;